export default function HowClassesWorkSection() {
  return (
    <section id="como-funciona" className="relative w-full bg-white py-16 md:py-20">
      <div className="w-full px-6 md:px-12 lg:px-16">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-12 lg:gap-20">
          {/* Texto */}
          <div className="w-full lg:w-1/2 flex flex-col gap-8">
            <div className="inline-flex self-start">
              <span className="font-sans text-[11px] font-semibold tracking-[0.2em] uppercase text-vibrant-blue bg-light-blue/10 px-4 py-2 rounded-full">
                Nosso Método
              </span>
            </div>

            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-night-blue leading-[1.15] tracking-tight max-w-[500px]">
              Como funcionam nossas aulas?
            </h2>

            <div className="flex flex-col gap-5 max-w-[520px]">
              <p className="font-sans text-[15px] md:text-base text-gray-500 leading-[1.8]">
                Uma vez por semana com a duração de 40 minutos à 1 hora, nossas aulas contemplam conteúdos práticos e teóricos, levando o aluno de forma simples a tocar e fluir na música.
              </p>
              <p className="font-sans text-[15px] md:text-base text-gray-500 leading-[1.8]">
                Toda aula termina com um momento de devocional, levando o aluno(a) a entender que a música é feita para o louvor e adoração a Deus.
              </p>
            </div>

            <div className="flex items-center gap-4 pt-2">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-vibrant-blue text-white">
                <i className="ri-music-2-line text-lg"></i>
              </div>
              <span className="font-sans text-sm font-medium text-gray-500">
                Aprenda com propósito e excelência
              </span>
            </div>
          </div>

          {/* Imagens - layout colagem */}
          <div className="w-full lg:w-1/2">
            <div className="relative w-full max-w-[520px] mx-auto lg:mx-0">
              {/* Imagem grande - teclado */}
              <div className="relative w-[72%] aspect-[3/4] rounded-2xl overflow-hidden">
                <img
                  src="https://storage.readdy-site.link/project_files/10dd6ff9-efe2-4505-9f10-13a932b2db17/3c1cb23a-961c-4706-8f62-33ab500aeb6f_compressed_side-view-young-girl-learning-how-play-electronic-keyboard-1.webp"
                  alt="Criança aprendendo a tocar teclado"
                  title="Aula de Teclado na TL Artes & Música"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Imagem menor - violão */}
              <div className="absolute bottom-0 right-0 w-[48%] aspect-[4/5] rounded-2xl overflow-hidden border-4 border-white shadow-lg">
                <img
                  src="https://storage.readdy-site.link/project_files/10dd6ff9-efe2-4505-9f10-13a932b2db17/31c48194-1e1e-47a1-a4da-db98ab78c5c4_compressed_little-girl-learning-how-play-guitar-home.webp"
                  alt="Criança aprendendo a tocar violão"
                  title="Aula de Violão na TL Artes & Música"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}